import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AiAssistantPromptPreset } from '@domain/ai-assistant/ai-assistant.models';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';

@Component({
  selector: 'app-ai-assistant-prompt-presets',
  imports: [LoadingSkeletonComponent, TranslatePipe],
  templateUrl: './ai-assistant-prompt-presets.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiAssistantPromptPresetsComponent {
  public readonly promptPresets = input<AiAssistantPromptPreset[] | undefined>(undefined);
  public readonly isLoading = input(false);
  public readonly disabled = input(false);

  public readonly promptPresetSelected = output<AiAssistantPromptPreset>();

  public onPromptPresetSelected(promptPreset: AiAssistantPromptPreset): void {
    this.promptPresetSelected.emit(promptPreset);
  }
}
